import { SELECT_EVENT_TYPE } from '../actions/selectedEventType';
import { SELECT_CAT } from '../actions/selectedCat';
export var selectedEventType = function selectedEventType() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case SELECT_EVENT_TYPE:
      return action.selectedEventType;
    case SELECT_CAT:
      if (state !== 'ongoing') {
        return 'ongoing';
      }
      return state;
    default:
      return state;
  }
};